import { createSlice } from "@reduxjs/toolkit";

export const chatbox = createSlice({
  name: "chatbox",
  initialState: {
    show: false,
    categoryId: null,
    chatObject: {
      tutorId: 0,
      isSingle: false,
      tutor: null,
    },
    unreadCount: 0, // <-- Add this to track unread messages
  },
  reducers: {
    changeChatbox: (state, action) => {
      state.show = action.payload;
    },
    changeChatObject: (state, action) => {
      state.chatObject = action.payload;
    },
    changeCategoryId: (state, action) => {
      state.categoryId = action.payload;
    },
    setUnreadCount: (state, action) => {
      state.unreadCount = action.payload; // <-- Update unread messages count
    },
    incrementUnreadCount: (state) => {
      state.unreadCount += 1; // <-- Increase count when a new message arrives
    },
    resetUnreadCount: (state) => {
      state.unreadCount = 0; // <-- Reset when the chat is opened
    },
  },
});

// Action creators are generated for each case reducer function
export const {
  changeChatbox,
  changeChatObject,
  changeCategoryId,
  setUnreadCount,
  incrementUnreadCount,
  resetUnreadCount,
} = chatbox.actions;

export const currentChatbox = (state) => state.chatbox.show;
export const currentChatObject = (state) => state.chatbox.chatObject;
export const currentCategoryId = (state) => state.chatbox.categoryId;
export const currentUnreadCount = (state) => state.chatbox.unreadCount; // <-- Add selector for unread messages

export default chatbox.reducer;
